import { Controller } from "@hotwired/stimulus"
import { Chart, BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js'

// Register Chart.js components for bar charts
Chart.register(BarElement, BarController, CategoryScale, LinearScale, Tooltip, Legend)

export default class extends Controller {
  static values = {
    data: Object  // { years: [2023, 2022, 2021], revenue: [100, 200, 300], expenses: [90, 180, 270] }
  }

  connect() {
    console.log('📊 RevenueExpenseChartController v1.0 loaded')
    this.renderChart()
  }

  renderChart() {
    if (!this.dataValue || !this.dataValue.years) {
      console.warn('Chart data not available', this.dataValue)
      return
    }

    const ctx = this.element

    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }

    // Ensure values are numbers
    const revenueValues = this.dataValue.revenue.map(v => Number(v) || 0)
    const expenseValues = this.dataValue.expenses.map(v => Number(v) || 0)

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.dataValue.years,
        datasets: [
          {
            label: 'Total Revenue',
            data: revenueValues,
            backgroundColor: '#A31D4B',  // Maroon/burgundy color
            borderWidth: 0,
            borderRadius: 2
          },
          {
            label: 'Total Expenses',
            data: expenseValues,
            backgroundColor: '#CECECE',  // Gray color
            borderWidth: 0,
            borderRadius: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: '#E5E5E5'
            },
            ticks: {
              callback: function(value) {
                if (value >= 1000000) {
                  return '$' + (value / 1000000).toFixed(1) + 'M'
                } else if (value >= 1000) {
                  return '$' + (value / 1000).toFixed(0) + 'K'
                }
                return '$' + value
              }
            }
          }
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 20,
              usePointStyle: true,
              pointStyle: 'rect',
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.dataset.label || ''
                const value = context.parsed.y || 0
                return `${label}: $${value.toLocaleString()}`
              }
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
